import { ComposeViewState } from 'owa-mail-compose-store';
import { action } from 'satcheljs/lib/legacy';

export default action('switchToReadWriteRecipient')(function switchToReadWriteRecipient(
    viewState: ComposeViewState
) {
    viewState.showCompactRecipientWell = false;
});
